<template>
  <div>
    <!-- Notification Banner -->
    <FrontendNotificationBanner v-if="showNotification" />

    <!-- Main Header -->
    <div class="relative z-50">
      <!-- Backdrop Blur Effect -->
      <div class="absolute inset-0 bg-white/80 backdrop-blur-md"></div>

      <!-- Header Content -->
      <div class="relative">
        <FrontendLayoutHeaderMobile :cart="cartState" :categories="categories" v-if="$device.isMobile" />
        <FrontendLayoutHeaderDesktop :cart="cartState" :categories="categories" v-else />
      </div>
      <!-- Bottom Border with Gradient -->
      <div class="h-[1px] bg-gradient-to-r from-transparent via-slate-200 to-transparent"></div>
    </div>

  </div>
</template>

<script setup>
const cartState = useCartStore()
const showNotification = ref(true)
const { API_ENDPOINTS } = useApiEndpoints()

const { data: categoriesData } = await useAsyncData('headerCategories', () =>
  useBaseOFetchWithAuth(API_ENDPOINTS.public.categories.hierarchicalList, {
    params: {
      transform: true
    }
  })
)

const categories = computed(() => {
  const raw = categoriesData.value?.data ?? categoriesData.value
  return Array.isArray(raw) ? raw : []
})
</script>

<style scoped>
/* Removed pattern-overlay and bg-image styles as they're not needed in the new design */
</style>
